<section class="p-2 p-md-4">

  <!-- BLOCO UNIDADE -->
  <div class="card mb-4">
    <div class="card-header bg-white">
      <h2>Dados Fatura</h2>
    </div>

    <div class="card-body row align-items-end">
      <div class="col-6 col-lg-3 p-2">
        <label for="referencia"> ID Fatura</label>
        <label id="referencia" type="text" class="form-control"> {{this.faturaCliente.id}} </label>
      </div>

      <div class="col-6 col-lg-3 p-2">
        <label for="referencia"> Faturamento Referente</label>
        <input [formControl]="form.controls.referencia" readonly id="referencia" type="text" class="form-control">
        <app-msg-erro [control]="form.controls.referencia"></app-msg-erro>
      </div>

      <div class="col-6 col-lg-3 p-2">
        <label for="referencia"> Gerar NFS-e</label>
        <input [formControl]="form.controls.referencia" readonly id="referencia" type="text" class="form-control">
        <app-msg-erro [control]="form.controls.referencia"></app-msg-erro>
      </div>

      <div class="col-6 col-lg-3 p-2">
        <label for="referencia"> Gerar Nota</label>
        <input [formControl]="form.controls.referencia" readonly id="referencia" type="text" class="form-control">
        <app-msg-erro [control]="form.controls.referencia"></app-msg-erro>
      </div>
    </div>
  </div>
  <!-- FIM BLOCO UNIDADE -->

  <!-- BLOCO UNIDADE -->
  <div class="card mb-4">
    <div class="card-header bg-white">
      <h2>Dados Unidade</h2>
    </div>

    <div class="card-body row align-items-end">

      <div class="col-6 col-lg-3 p-2">
        <label for="referencia"> ID Unidade</label>
        <label id="referencia" type="text" class="form-control"> {{this.faturaCliente.idUnidade}} </label>
      </div>

      <div class="col-lg-6 col-12 p-2">
        <label for="razaoSocial">Razão Social</label>
        <input [formControl]="form.controls.razaoSocial" type="text" id="razaoSocial" class="form-control">
        <app-msg-erro [control]="form.controls.razaoSocial"></app-msg-erro>
      </div>

      <div class="col-lg-6 col-12 p-2">
        <label for="nomeFantasia">Nome Fantasia</label>
        <input [formControl]="form.controls.nomeFantasia" type="text" id="nomeFantasia" class="form-control">
        <app-msg-erro [control]="form.controls.nomeFantasia"></app-msg-erro>
      </div>

      <div class="col-6 col-lg-3 p-2">
        <label for="documento">Documento</label>
        <input [formControl]="form.controls.documento" id="documento" type="text" class="form-control">
        <app-msg-erro [control]="form.controls.documento"></app-msg-erro>
      </div>

      <div class="col-6 col-lg-3 p-2">
          <label for="telefone">Telefone Contato</label>
          <input [textMask]="masks.telefone" [formControl]="form.controls.telefone" id="telefone" type="text" class="form-control">
          <app-msg-erro [control]="form.controls.telefone"></app-msg-erro>
      </div>

      <div class="col-6 col-lg-3 p-2">
          <label for="email">E-mail Contato</label>
          <input [formControl]="form.controls.email" id="email" type="text" class="form-control">
          <app-msg-erro [control]="form.controls.email"></app-msg-erro>
      </div>

      <div class="col-6 col-lg-3 p-2">
          <label for="referencia"> Faturamento Referente</label>
          <input [formControl]="form.controls.referencia" readonly id="referencia" type="text" class="form-control">
          <app-msg-erro [control]="form.controls.referencia"></app-msg-erro>
      </div>
    </div>
  </div>
  <!-- FIM BLOCO UNIDADE -->

  <!-- BLOCO ENDERECO -->
  <div class="card mb-4">
    <div class="card-header bg-white">
      <h2>Dados Endereço</h2>
    </div>
    
    <div class="card-body row align-items-end">
      
      <div class="col-6 col-lg-3 p-2">
        <label for="cep">CEP</label>
        <input [textMask]="masks.cep" autocomplete="false" [formControl]="form.controls.cep" id="cep" type="text" class="form-control input-validate">
        <app-msg-erro [control]="form.controls.cep"></app-msg-erro>
      </div>
      
      <div class="col-6 col-lg-3 p-2">
        <label for="rua">Rua</label>
        <input [formControl]="form.controls.rua" id="rua" type="text" class="form-control">
        <app-msg-erro [control]="form.controls.rua"></app-msg-erro>
      </div>
      
      <div class="col-6 col-lg-3 p-2">
        <label for="bairro">Bairro</label>
        <input [formControl]="form.controls.bairro" id="bairro" type="text" class="form-control">
        <app-msg-erro [control]="form.controls.bairro"></app-msg-erro>
      </div>
      
      <div class="col-6 col-lg-3 p-2">
        <label for="numero">Numero</label>
        <input [formControl]="form.controls.numero" id="numero" type="number" class="form-control">
        <app-msg-erro [control]="form.controls.numero"></app-msg-erro>
      </div>
      
      <div class="col-6 col-lg-3 p-2">
        <label for="cidade">Cidade</label>
        <input [formControl]="form.controls.cidade" id="cidade" type="text" class="form-control">
        <app-msg-erro [control]="form.controls.cidade"></app-msg-erro>
      </div>
      
      <div class="col-6 col-lg-3 p-2">
        <label for="estado">Estado</label>
        <input [formControl]="form.controls.estado" id="estado" type="text" class="form-control">
        <app-msg-erro [control]="form.controls.estado"></app-msg-erro>
      </div>
    </div>
  </div>
  <!-- FIM BLOCO ENDERECO -->
  
  
  
  <!-- BLOCO CONSULTA -->
  <div *ngIf="listaConsulta.length>0" class="card mt-4">
    
    <div class="card-header bg-white">
      <h2>Consultas</h2>
    </div>
  
    <div class="card-body p-0">
      <div class="row">

        <ng-container *ngFor="let c of listaConsulta; let i = index">
          <div class="col-6">
            <div class="border border-light d-block h-100">
              <div class="row">
                <div class="fw-500 py-2">
                  <span>{{c.controls.nomeConsulta.value}}</span>
                  <div class="p-1 mt-1 rounded bg-light w-100 d-flex align-items-center justify-content-between">

                    <div class="w-50 px-1">
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text px-1 px-sm-2">Quantidade</span>
                        </div>
                        <input [formControl]="c.controls.quantidade" type="number" class="form-control">
                      </div>
                      <app-msg-erro [control]="c.controls.quantidade"></app-msg-erro>
                    </div>

                    <div class="w-50 px-1">
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text px-1 px-sm-2">R$</span></div>
                        <input [textMask]="masks.decimal" [formControl]="c.controls.valorUnitario" type="text"
                          class="form-control">
                      </div>
                      <app-msg-erro [control]="c.controls.valorUnitario"></app-msg-erro>
                    </div>

                    <div class="w-50 px-1">
                      Subtotal: R$ {{ valorTotalProduto(c.controls.quantidade.value, c.controls.valorUnitario.value) |
                      number:'1.2-2'}}
                    </div>

                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-4 offset-md-4" class="fw-300 py-2">
                  <label>
                    Refletir valores na tabela de preço:
                  </label>
                </div>

                <div class="col-4">
                  <input style="width: auto;" type="checkbox" [formControl]="c.controls.atualizarTabelaPreco"
                    class="form-control" />
                </div>
                <!-- <div class="col-4">
                    <label>
                      Consulta Cortesia: {{c.controls.cortesia.value? 'SIM':'NÃO'}}
                    </label>
                  </div> -->
              </div>
            </div>
          </div>

        </ng-container>

      </div>
    </div>
  </div>
  <!-- FIM BLOCO CONSULTA -->



  <!-- BLOCO CORTESIA -->
  <div *ngIf="listaCortesia.length>0" class="card mt-4">

    <div class="card-header bg-white">
      <h2>Cortesias</h2>
    </div>

    <div class="card-body p-0">
      <div class="row">

        <ng-container *ngFor="let c of listaCortesia; let i = index">
          <div class="col-6">
            <div class="border border-light d-block h-100">
              <div class="row">
                <div class="fw-500 py-2">
                  <span>{{c.controls.nomeConsulta.value}}</span>
                  <div class="p-1 mt-1 rounded bg-light w-100 d-flex align-items-center justify-content-between">

                    <div class="w-50 px-1">
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text px-1 px-sm-2">Quantidade</span>
                        </div>
                        <input [formControl]="c.controls.quantidade" type="number" class="form-control">
                      </div>
                      <app-msg-erro [control]="c.controls.quantidade"></app-msg-erro>
                    </div>

                    <div class="w-50 px-1">
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text px-1 px-sm-2">R$</span></div>
                        <input [textMask]="masks.decimal" [formControl]="c.controls.valorUnitario" type="text"
                          class="form-control">
                      </div>
                      <app-msg-erro [control]="c.controls.valorUnitario"></app-msg-erro>
                    </div>

                    <div class="w-50 px-1">
                      Subtotal: R$ {{ valorTotalProduto(c.controls.quantidade.value, c.controls.valorUnitario.value) |
                      number:'1.2-2'}}
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </ng-container>

      </div>
    </div>
  </div>
  <!-- FIM BLOCO CORTESIA -->




  <!-- BLOCO LAUDO -->
  <div *ngIf="listaLaudo.length>0" class="card mt-4">

    <div class="card-header bg-white">
      <h2>Laudo</h2>
    </div>

    <div class="card-body p-0">
      <div class="row">

        <ng-container *ngFor="let c of listaLaudo; let i = index">
          <div class="col-6">
            <div class="border border-light d-block h-100">
              <div class="row">
                <div class="fw-500 py-2">
                  <span>{{c.controls.nomeLaudo.value}}</span>
                  <div class="p-1 mt-1 rounded bg-light w-100 d-flex align-items-center justify-content-between">

                    <div class="w-50 px-1">
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text px-1 px-sm-2">Quantidade</span>
                        </div>
                        <input [formControl]="c.controls.quantidade" type="number" class="form-control">
                      </div>
                      <app-msg-erro [control]="c.controls.quantidade"></app-msg-erro>
                    </div>

                    <div class="w-50 px-1">
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text px-1 px-sm-2">R$</span></div>
                        <input [textMask]="masks.decimal" [formControl]="c.controls.valorUnitario" type="text"
                          class="form-control">
                      </div>
                      <app-msg-erro [control]="c.controls.valorUnitario"></app-msg-erro>
                    </div>

                    <div class="w-50 px-1">
                      Subtotal: R$ {{ valorTotalProduto(c.controls.quantidade.value, c.controls.valorUnitario.value) |
                      number:'1.2-2'}}
                    </div>

                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-4 offset-md-4" class="fw-300 py-2">
                  <label>
                    Refletir valores na tabela de preço:
                  </label>
                </div>

                <div class="col-4">
                  <input style="width: auto;" type="checkbox" [formControl]="c.controls.atualizarTabelaPreco"
                    class="form-control" />
                </div>
              </div>
            </div>
          </div>

        </ng-container>

      </div>
    </div>
  </div>
  <!-- FIM BLOCO LAUDO -->

  <!-- BLOCO DESCONTO -->
  <div class="card mt-4">

    <div class="card-header bg-white">
      <h2>Acréscimo/Desconto</h2>
      <button (click)="addDesconto()" class="btn btn-lg px-5 btn-info">
        <span>+</span>
      </button>
    </div>

    <div class="card-body p-0">


      <ng-container *ngFor="let c of listaDesconto; let i = index">
        <div class="row">
          <div class="col-6 col-lg-3 p-2">
            <label for="descricao">Descrição:</label>
            <input [formControl]="c.controls.descricao" id="descricao" type="text" class="form-control">
            <app-msg-erro [control]="c.controls.descricao"></app-msg-erro>
          </div>

          <div class="col-6 col-lg-3 p-2">
            <label for="tipo">Tipo:</label>
            <select [formControl]="c.controls.tipo" name="tipo" class="form-control input-validate">
              <option>ACRESCIMO</option>
              <option>DESCONTO</option>
            </select>
            <app-msg-erro [control]="c.controls.descricao"></app-msg-erro>
          </div>

          <div class="col-5 col-lg-3 p-2">
            <label for="valor">Valor Desconto:</label>

            <div class="input-group">
              <div class="input-group-prepend"><span class="input-group-text px-1 px-sm-2">R$</span></div>
              <input [textMask]="masks.decimal" [formControl]="c.controls.valor" type="text" class="form-control">
            </div>
            <app-msg-erro [control]="c.controls.valor"></app-msg-erro>
          </div>

          <div class="col-1 p-2">
            <button (click)="removerDesconto(i)" class="btn btn-lg px-5 btn-danger">
              <span>-</span>
            </button>
          </div>
        </div>

      </ng-container>

    </div>
  </div>
  <!-- FIM BLOCO DESCONTO -->

  <!-- RESUMO -->
  <div class="row">
    <div class="col-12 p-2 bg-white d-flex justify-content-end fw-500" [ngClass]="{'text-danger': valorConsulta()<0}">
      Valor Consulta: R$ {{ valorConsulta() | number:'1.2-2'}}
    </div>

    <div class="col-12 p-2 bg-white d-flex justify-content-end fw-500" [ngClass]="{'text-danger': valorCortesia()<0}">
      Valor Cortesia: R$ {{ valorCortesia() | number:'1.2-2'}}
    </div>

    <div class="col-12 p-2 bg-white d-flex justify-content-end fw-500" [ngClass]="{'text-danger': valorLaudo()<0}">
      Valor Laudo: R$ {{ valorLaudo() | number:'1.2-2'}}
    </div>

    <div class="col-12 p-2 bg-white d-flex justify-content-end fw-500" [ngClass]="{'text-danger': valorDescontos()<0}">
      Valor Acréscimo/Desconto: R$ {{ valorDescontos() | number:'1.2-2'}}
    </div>

    <div class="col-12 p-2 bg-white d-flex justify-content-end fw-500" [ngClass]="{'text-danger': valorTotal()<0}">
      Valor Total: R$ {{ valorTotal() | number:'1.2-2'}}
    </div>
  </div>
  <!-- RESUMO -->

  <div class="card-body bg-white d-flex justify-content-between">
    <button (click)="voltar()" class="btn btn-lg px-5 btn-primary">
      <span>Voltar</span>
    </button>

    <button (click)="sendForm()" class="btn btn-lg px-5 btn-success">
      <span>Verificar/Salvar</span>
    </button>
  </div>
</section>
